<!-- 
    1.colorbar的顏色from第一個載完的csv, 不一定是第一個餵進去的
-->

<template>
    <span :id="'render_v2_' + name"></span>
</template>

<script>
import axios from 'axios'

export default {
    name: 'kxd-render',
    props: ['name', 'text', 'options', 'pane', 'cursor_latlng', 'colorbar'],
    data: function () {
        return {
            version: '[kxd-render] 2025/09/03',
            usable_idx_list: [],
            render_type: this.options.type, //pixel|pixel_contour|pixel_plus_contour|symbol|symbol_wind|particle
            render_max: this.options.render_max || 100, //最大輪播資料頁數
            mode: this.options.mode || 0,
            smooth: this.options.smooth || 0,
            contour: this.options.contour || {},
            idx_map: new Map(), //for key=>player idx
            xLayer: null,
            is_layer_show: true,
            render_color_status: this.pane.options.render_hint.render_color_status || null, //預設關閉色階
        }
    },
    components: {},
    computed: {
        has_colorbar: function (params) {
            //是否產製colorbar

            //無colorbar產品: particle
            if (['particle'].includes(this.render_type)) return false

            // symbol_wind: 使用header上色時
            if (['symbol_wind'].includes(this.render_type)) {
                if (this.pane.options.render_hint.layer.windbarColor === null) return true
            }

            if (!this.pane.options.render_hint.colorbar) return false
            return this.pane.options.render_hint.colorbar.show === false ? false : true
        },
        layer_id() {
            return this.xLayer._leaflet_id
        },
        is_initial() {
            if (!this.xLayer) return false

            return this.xLayer.isInit
        },
        is_custom_contour() {
            // 是否為自訂等值線
            return this.contour.color_list && this.contour.val_list
        },
        pick_data() {
            if (!this.xLayer) return null
            else if (!this.colorbar) return null
            else if (!this.is_layer_show) return null
            else if (!this.xLayer.pickData) return null

            return this.xLayer.pickData(this.cursor_latlng.lng, this.cursor_latlng.lat)
        },
    },
    beforeMount: function () {},
    mounted: function () {
        this.initial()
        this.load_data()
        this.extend_pane_render()
    },
    methods: {
        initial() {
            // initial params
            this.usable_idx_list = new Array(this.render_max).fill(0).map((o, i) => i)

            // initial layer
            const xlayer_options = {
                pane: this.name,
                projection: this.pane._map.options.crs.code,
                ...this.options.layer,
            }
            /*
            [layer選項]
                -[symbol產品]
                    dataTrans: 'uv', //uv分量
                    fillOut: true, //解析度大於資料的時候要不要補點, 預設: false
                -[symbol_wind產品]
                    dataTrans: 'uv', //uv分量
                    windbarColor: '#fff', //風標顏色, 預設: #000
                -[particle產品]
                    dataTrans: 'uv', //uv分量
                    particle: true,
                    paleAlpha: 0.9, // 越小殘影越快消失 0 ~ 1
            */

            this.xLayer = new L.xLayer(xlayer_options).addTo(this.pane)
            if (this.options.header) this.xLayer.setHeader(this.options.header)
        },
        set_color_status() {
            if (!this.render_color_status) return

            this.render_color_status.forEach((status, lv) => {
                if (!status) this.xLayer.switchColor(lv)
            })
        },
        set_colorbar() {
            const { colors, values } = this.xLayer.getColors()
            this.options.colorbar.color_list = this.get_color_list(colors)
            this.options.colorbar.val_list = values
            this.options.colorbar.title = this.options.colorbar.title || this.text
            if (this.render_color_status) this.options.colorbar.color_status = this.render_color_status

            this.$emit('create_colorbar', {
                status: true,
                name: this.name,
                setting: this.options.colorbar,
                switch: (lv, layersDisable) => {
                    this.xLayer.switchColor(lv)

                    // color status 紀錄在pane上
                    this.pane.options.render_hint.render_color_status = layersDisable
                },
                callback: () => {},
            })
        },
        set_contour_colorbar() {
            this.options.colorbar.color_list = this.get_color_list(this.contour.color_list)
            this.options.colorbar.val_list = this.contour.val_list
            this.options.colorbar.title = this.options.colorbar.title || this.text
            this.options.colorbar.cursor_list = null

            this.$emit('create_colorbar', {
                status: true,
                name: this.name,
                setting: this.options.colorbar,
                callback: () => {},
            })
        },
        get_color_list(list) {
            let color_list = []
            for (let i = 0, len = list.length; i < len; i += 3) {
                color_list.push('rgb(' + list.slice(i, i + 3).join(',') + ')')
            }

            return color_list
        },
        extend_pane_render(params) {
            // extend function for pane
            if (!this.pane.render) this.pane.render = {}

            // set pane.render params
            this.pane.render.last_key = null // 最後顯示的key

            // colorbar switch時, 會更新 this.pane.options.render_hint.render_color_status

            this.pane.render.is_exist = this.is_exist
            this.pane.render.add_data = this.add_data
            this.pane.render.change = this.change
            this.pane.render.set_mode = this.set_mode
            this.pane.render.set_smooth = this.set_smooth
            this.pane.render.remove_render_layer = this.remove_render_layer
            this.pane.render.add_render_layer = this.add_render_layer
        },
        is_exist(key) {
            return this.idx_map.has(String(key))
        },
        add_data(options) {
            const idx = this.usable_idx_list.shift()
            const data = options.data
            const key = data.key
            let requests = options.requests || []

            if (!data.url) {
                //無路徑時, 該頁插入空值
                this.insert_data(idx, key, null, () => {
                    if (options.callback) options.callback()
                })
            } else {
                this.get_csv(requests, data, key, (csv_data, key) => {
                    this.insert_data(idx, key, csv_data, () => {
                        if (options.callback) options.callback()
                    })
                })
            }
        },
        get_csv(
            //同產品的csv需全部載完, 再加至render
            requests_list,
            data,
            key,
            callback
        ) {
            if (typeof data.url === 'string') data.url = [data.url]

            const csv_requests = data.url.map((url, i) => {
                let config = {}
                if (this.options.data_type === 'tif') config['responseType'] = 'blob'

                const request = axios.get(url, config)
                requests_list.push(request)
                return request
            })

            axios
                .all(csv_requests)
                .then(
                    axios.spread((spd, dir) => {
                        let csv_data = {}

                        if (spd) csv_data.spd = spd.data
                        if (dir) csv_data.dir = dir.data

                        if (this.options.data_type === 'tif') {
                            const tif = this.options.tif
                            const color_text = tif && tif.color_text
                            if (!color_text)
                                this.$parent.log('[Vue Map > kxd-render-v2] tif 請設定 render_hint.color_text')

                            async function _trans_tif() {
                                const csv = await tif2csv(csv_data.spd, color_text, function (v) {
                                    if (tif.callback) return tif.callback(v)
                                    return v
                                })

                                csv_data.spd = csv.data()
                                callback(csv_data, key)
                            }
                            return _trans_tif()
                        }

                        callback(csv_data, key)
                    })
                )
                .catch((err) => {
                    this.$parent.log('[Vue Map > kxd-render-v2] Create render error: ', err)
                    callback(null, key)
                })
        },
        insert_data(idx, key, data, callback) {
            // save for change data
            this.idx_map.set(String(key), idx)

            //取資料時失敗, 該頁插入空值
            if (!data || !Object.keys(data).length) {
                this.add_data_to_xlayer(idx, {}, callback)
                return
            }

            //已經初始化的話, 直接添加資料
            if (this.is_initial) return this.add_data_to_xlayer(idx, data, callback)

            //未初始化的話, 先用第一筆資料initial render
            if (['pixel', 'pixel_contour', 'pixel_plus_contour'].includes(this.render_type)) {
                // getPixel的callback只會跑一次
                // 所以遇到第一筆失敗的情況, 要再跑一次getPixel但是不跑callback
                if (!this.xLayer.timeline) {
                    this.xLayer.getPixel(this.render_max, [data.spd], () => {
                        this.add_data_to_xlayer(idx, data, callback)
                    })
                } else {
                    this.xLayer.getPixel(this.render_max, [data.spd], () => {})
                    this.add_data_to_xlayer(idx, data, callback)
                }
            } else if (['symbol'].includes(this.render_type)) {
                this.xLayer.getSymbol(this.render_max, [data.spd, data.dir], () => {
                    this.add_data_to_xlayer(idx, data, callback)
                })
            } else if (['symbol_wind'].includes(this.render_type)) {
                this.xLayer.getWindbar(this.render_max, [data.spd, data.dir], () => {
                    this.add_data_to_xlayer(idx, data, callback)
                })
            } else if (['particle'].includes(this.render_type)) {
                this.xLayer.getParticle(this.render_max, [data.spd, data.dir], () => {
                    this.add_data_to_xlayer(idx, data, callback)
                })
            }
        },
        add_data_to_xlayer(idx, data, callback) {
            let render_data = []
            if (data.spd) render_data.push(data.spd)
            if (data.dir) render_data.push(data.dir)

            if (render_data.length) {
                this.xLayer.addData(idx, render_data)
            } else {
                // 資料毀損 -> 塞空資料
                // this.xLayer.addData(idx, [''])
            }

            if (callback) callback()
        },
        load_data() {
            // load csv data
            let requests = []
            let requests_count = 0

            let load_list = this.options.list.slice()

            load_list.forEach((data) => {
                requests_count++
                this.add_data({
                    data: data, //{key, url}
                    requests: requests,
                    callback: () => {
                        requests_count--
                        if (!requests_count) {
                            //  ★ all loaded
                            this.loaded()
                        }
                    },
                })
            })
        },
        loaded() {
            //全部載完後, 顯示最後一頁
            const last_key = this.options.list[this.options.list.length - 1].key
            this.change(last_key)

            if (this.options.callback) this.options.callback(this.layer_id)
        },
        change(key) {
            // change page
            const idx = this.idx_map.get(String(key))

            if (this.xLayer.timeline) this.xLayer.timeline.change(idx)
            else throw '[Vue Map > kxd-render-v2] xLayer.timeline is undefined'

            // log last play page
            this.pane.render.last_key = key
        },
        set_mode(mode) {
            if (!['pixel', 'pixel_contour', 'pixel_plus_contour'].includes(this.render_type)) return

            this.xLayer.setDisplayMode(mode)
        },
        set_smooth(status) {
            if (!['pixel', 'pixel_contour', 'pixel_plus_contour'].includes(this.render_type)) return

            this.xLayer.setSmoothing(status)
        },
        remove_render_layer: function () {
            // 擴充 for map.vue remove_pane
            this.is_layer_show = false
        },
        add_render_layer: function () {
            // 擴充 for map.vue add_pane
            this.is_layer_show = true

            this.change(this.pane.render.last_key)
        },
        get_rgb: function (color) {
            if (!color) return [0, 0, 0] //預設為黑色
            else if (color == 'auto') return 'auto'

            //判斷是rgb還是#色碼 => 輸出[r, g, b]
            let rgb_list = null
            if (color.startsWith('#') && color.length === 4) {
                const result = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(color)
                rgb_list = [
                    parseInt(result[1] + result[1], 16),
                    parseInt(result[2] + result[2], 16),
                    parseInt(result[3] + result[3], 16),
                ]
            } else if (color.startsWith('#') && color.length === 7) {
                const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color)
                rgb_list = [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
            } else if (color.startsWith('rgb')) {
                const result = color.substring(4).split(')')[0].split(',')
                rgb_list = [Number(result[0]), Number(result[1]), Number(result[2])]
            }

            if (!rgb_list) return this.$parent.log('[Vue Map > kxd-render-v2] get contour color error')

            return rgb_list
        },
    },
    watch: {
        is_initial: function (status) {
            if (!status) return

            if (this.mode) this.set_mode(this.mode)
            else if (this.render_type === 'pixel_contour') this.set_mode(1)
            else if (this.render_type === 'pixel_plus_contour') this.set_mode(2)

            if (this.smooth) this.set_smooth(this.smooth)

            //設定毛毛蟲顏色
            if (this.render_type === 'particle' && this.pane.options.render_hint.particle) {
                const setting = this.pane.options.render_hint.particle
                //預設為 [0, 0, 0]）粒子顏色 (0~255)
                if (setting.color) this.xLayer.drawer.setColor(setting.color)
                //預設為1000, 粒子總數量
                if (setting.count) this.xLayer.drawer.setCount(setting.count)
                //預設[3000,4000],[300,400] 粒子隨機顯示[N1~N2]毫秒 & 隨機停止[N3~N4]毫秒
                if (setting.life_time) this.xLayer.drawer.setLifeTime(setting.life_time[0], setting.life_time[1])
                //預設值為計算出。粒子移動速度準則：以實際 quantity 數值為準，當粒子為該數值時，每個影格會以 pixels 個像素移動，其餘數值皆以等比例計算
                //ex. (100,1000) = 粒子每100差值走1000的pixel
                if (setting.speed) this.xLayer.drawer.setSpeed(setting.speed[0], setting.speed[1])
            }

            //設定等值線顏色、樣式
            // 自訂顏色表
            if (this.is_custom_contour)
                this.xLayer.setContourVals(this.contour.color_list, this.contour.val_list, this.contour.label_list)
            // 使用自動色 & 關閉label
            else if (this.contour.label == false) this.xLayer.setContourVals(this.get_rgb(this.contour.color), null, [])
            // 自訂單一色
            else if (this.contour.color) this.xLayer.setContourVals(this.get_rgb(this.contour.color))

            const tangent = this.contour.tangent === false ? false : true //是否沿切線方向
            const labelSize = this.contour.label_size || 20 //字體大小, 預設20
            if (!tangent || labelSize !== 20) this.xLayer.setContourTextStyle(labelSize, null, tangent)

            //設定colorbar
            if (!this.has_colorbar) return
            if (this.render_type == 'pixel_contour' && this.is_custom_contour) {
                this.set_contour_colorbar()
            } else {
                this.set_colorbar()
                this.set_color_status()
            }
        },
        pick_data(params) {
            if (!this.colorbar.length) return

            // update colorbar data
            if (!params) return this.colorbar[0].change_cursor(null, [])
            else if (this.render_type == 'pixel_contour' && this.is_custom_contour) return

            this.colorbar[0].change_cursor(params.colorLv, params.data)
        },
    },
    beforeDestroy: function () {},
}
</script>

<style scoped></style>
